export const SET_USER = 'SET_USER';
export const SET_REVIEWS = 'SET_REVIEWS';
export const SET_ACTIVE_TICKET = 'SET_ACTIVE_TICKET';
export const SET_ACTIVE_PLACE = 'SET_ACTIVE_PLACE';
export const SET_ACTIVE_ORGANIZATION = 'SET_ACTIVE_ORGANIZATION';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_ACTIVE_FILTERS_OPTONS = 'SET_ACTIVE_FILTERS_OPTONS';
export const RESET_ACTIVE_FILTERS_OPTONS = 'RESET_ACTIVE_FILTERS_OPTONS';
export const SET_SIDEBAR_COLLAPSED = 'SET_SIDEBAR_COLLAPSED';
